import { CallSheetEntry } from "../steps/AddStreamTeamAssignment";

export const FormatCrew = (entries: CallSheetEntry[]): CallSheetEntry[] => {
  const roleOrder = [
    "Executive Producer",
    "Producer",
    "Assistant Producer",
    "Liveswitcher",
    "Camera",
    "Networking",
    "Sound",
    "Tribute Table",
  ];

  const normalizeRole = (role?: string): string => {
    if (!role) return "N/A";
    const normalized = role.trim().toLowerCase();

    if (normalized.startsWith("camera")) return "Camera";

    const match = roleOrder.find((r) => r.toLowerCase() === normalized);
    return match || role;
  };

  return [...entries].sort((a, b) => {
    const roleA = normalizeRole(a.assignment?.[0]?.role);
    const roleB = normalizeRole(b.assignment?.[0]?.role);

    const indexA = roleOrder.findIndex((r) => r === roleA);
    const indexB = roleOrder.findIndex((r) => r === roleB);

    if (indexA !== -1 && indexB !== -1) return indexA - indexB;
    if (indexA !== -1) return -1;
    if (indexB !== -1) return 1;

    return roleA.localeCompare(roleB);
  });
};
